import { AppStatusPage } from '@components/common/AppStatusPage';

export interface AppErrorPageProps {
  message?: string;
  errorCode?: string;
  onRetry?: () => void;
}

export function AppErrorPage({
  message = 'Something unexpected happened while loading this page.',
  errorCode = 'APP_RENDER_ERROR',
  onRetry,
}: AppErrorPageProps) {
  return (
    <AppStatusPage
      title="Something went wrong"
      iconType="exclamation-triangle"
      iconColorVariant="red"
      message={<p>{message}</p>}
      errorCode={errorCode}
      primaryAction={{
        label: 'Try again',
        onClick: onRetry ?? (() => window.location.reload()),
      }}
      secondaryAction={{ label: 'Go to home', to: '/', variant: 'outline' }}
    />
  );
}
